type ListRemovalError = {
  notFound: boolean;
};

const listRemovalError: ListRemovalError = {
  notFound: false,
};

export type { ListRemovalError };

export { listRemovalError };
